import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'ki-badges',
  title: 'KI Badges',
  description: 'Überblick über Ihre KI-Erfolge in den Anwenderkreisen.',
  icon: 'TrendingUp',
  order: 20,
  apiBasePath: '/api/ki-badges',

  // Leeres Array: für alle angemeldeten Nutzer sichtbar.
  // Sobald hier eine Rolle steht, sehen nur Nutzer mit dieser Rolle das Modul.
  roles: [],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
